<template>
  <div class="c-openingHours">
    <div
      class="o-heading o-heading--border o-grid o-grid--gutter-tiny o-grid--align-items-center"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-3">
            {{ translationsOpeningHours.sectionName || name }}
          </h3>
        </div>
      </div>
    </div>
    <div
      v-for="(day, name, index) in availabilityAll.weekdays"
      :key="index"
      class="o-grid o-grid--gutter-large o-grid--padding-none o-grid--align-items-start o-field o-field--spacing-none o-field--border"
    >
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--3">
          <div
            class="o-label"
            :title="translationsOpeningHours.weekdays[name] || ''"
          >
            {{ translationsOpeningHours.weekdays[name] || "" }}
          </div>
        </div>
        <div class="o-grid__item o-grid__item--3">
          <v-select
            label="name"
            :key="resetKey"
            v-model="day.status"
            :options="availabilityOptions"
            :class="{ active: isEditing }"
            :reduce="option => option.value"
            :searchable="true"
            :clearable="false"
            :filterBy="filterDropdownFistLetter"
            :selectOnTab="true"
            :disabled="!isEditing"
            @input="setClosed($event, name)"
          ></v-select>
        </div>
        <div
          v-if="day.timespans.length > 0"
          class="o-grid__item o-grid__item--5"
        >
          <div
            v-for="(span, spanIndex) in day.timespans"
            :key="spanIndex"
            class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--grow-0">
                <v-time
                  v-model="span.begin"
                  :disabled="!isEditing"
                  :class="{
                    active: isEditing
                  }"
                />
              </div>
              <div
                class="o-grid__item o-grid__item--1"
                style="text-align:center;"
              >
                -
              </div>
              <div class="o-grid__item o-grid__item--grow-0">
                <v-time
                  v-model="span.end"
                  :disabled="!isEditing"
                  :class="{
                    active: isEditing
                  }"
                />
              </div>
              <div class="o-grid__item o-grid__item--2">
                <button
                  v-if="isEditing && spanIndex > 0"
                  class="o-button o-button--action o-button--round o-button--light"
                  @click="deleteTimeSpan(name, spanIndex)"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-delete"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="isEditing && canAddSpans(name)"
            class="o-grid o-grid--gutter-tiny o-grid--align-items-center o-field o-field--spacing-10"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--12">
                <button
                  type="button"
                  class="o-button o-button--transparent o-button--clean"
                  :title="translationsOpeningHours.addPeriod || ''"
                  @click="addTimeSpan(name)"
                >
                  {{ translationsOpeningHours.addPeriod || "" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "c-openingHours",
  data() {
    return {
      section: "availability",
      name: "Tilgængelighed",
      resetKey: 0
    };
  },
  props: {
    isEditing: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters("aed", ["parameters"]),
    ...mapState("availability", {
      availabilityAll: "all",
      defaultTimeSpan: "defaultTimeSpan"
    }),
    ...mapState("translations", {
      translationsAvailabilityFull: "availability"
    }),
    translationsOpeningHours() {
      return this.translationsAvailabilityFull.openingHours;
    },

    availabilityOptions() {
      const availabilityOptions = [
        {
          name: this.translationsOpeningHours.state[0] || "",
          value: "Closed"
        },
        {
          name: this.translationsOpeningHours.state[1] || "",
          value: "Open"
        }
      ];
      return availabilityOptions;
    }
  },
  methods: {
    setClosed(value, name) {
      let item = this.availabilityAll.weekdays[name];
      item["status"] = value;
      if (item["status"] === "Closed") {
        item.timespans.length = 0;
      }
      if (item["status"] === "Open") {
        this.$set(
          item.timespans,
          0,
          JSON.parse(JSON.stringify(this.defaultTimeSpan))
        );
      }
    },
    addTimeSpan(dayName) {
      this.availabilityAll.weekdays[dayName].timespans.push(
        JSON.parse(JSON.stringify(this.defaultTimeSpan))
      );
    },
    deleteTimeSpan(dayName, spanIndex) {
      this.availabilityAll.weekdays[dayName].timespans.splice(spanIndex, 1);
    },

    canAddSpans(name) {
      const canAddSpans =
        this.availabilityAll.weekdays[name].status === "Open" &&
        this.availabilityAll.weekdays[name].timespans.length < 3;
      return canAddSpans;
    }
  }
};
</script>

<style lang="scss">
.c-openingHours {
}
</style>
